
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Ertigacabpune() {
    const cardData =
    {
        keyword: 'Ertiga Cab Pune',
        heading: 'Meghana Cab : Ertiga Cab Pune',
        headingDescription: 'Meghana Cab offers spacious and affordable Ertiga Cab services in Pune, ideal for family trips, group travel, airport transfers, and outstation journeys. The Maruti Suzuki Ertiga provides a perfect balance of comfort, utility, and fuel efficiency, with ample legroom and luggage space for up to 6 passengers. Whether you are planning a pilgrimage, business tour, or weekend escape, our well-maintained Ertiga cabs and experienced drivers ensure a smooth and enjoyable ride. With transparent pricing, on-time pickups, and 24/7 customer support, book your Ertiga Cab in Pune with Meghana Cab for a hassle-free travel experience tailored to your needs.',
        top: 'Top Places to Visit in Pune with Meghana Cab',
"topPlaces": [
   {
    "title": "Osho Ashram (Meditation Resort)",
    "description": "Nestled in lush Koregaon Park, this global meditation centre promotes wellness through guided meditations, yoga, therapies, and silent retreats. Housed in serene halls with beautifully maintained gardens, it provides a space for introspection and rejuvenation." 
  },
    {
    "title": "Sinhagad Fort",
    "description": "Perched at 1,317 m on the Sahyadri range, this ancient hill fortress—famed for the 1670 Battle of Sinhagad—offers rugged treks, two main gateways (Pune & Kalyan Darwaza), Tanaji Malusare’s memorial, and sweeping vistas of the Deccan Plateau. It’s a beloved weekend trek with food stalls serving local fare." 
  },
    {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 as the seat of the Maratha Peshwas, this iconic fortification features grand teak gateways, granite walls, ornate fountains, and remnants of its former glory. Despite a destructive fire in 1828, the five surviving gates—like the Delhi and Mastani Darwaza—and the palace ruins offer a journey into Maratha power and intrigue, often brought to life during the evening light-and-sound show." 
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 with Italian arches and set amidst sprawling lawns, this palatial structure served both famine relief and later the Indian freedom struggle—Mahatma Gandhi and his family were interned here. Now a museum, it preserves Gandhi’s personal items and the samadhis of Kasturba Gandhi and Mahadev Desai, echoing India’s fight for independence." 
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th‑century monolithic rock‑cut Shiva temple carved from basalt, this subterranean sanctum includes a circular Nandi mandapa with intricately carved pillars and a unique ‘underworld’ symbolism, all nestled within a peaceful urban heritage setting." 
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most celebrated sacred sites, this temple houses a lavishly adorned gold Ganesh idol and draws devotees year‑round. During Ganesh Chaturthi, its vibrant rituals, processions, and communal spirit make it a cultural highlight." 
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Pune’s second‑highest hill at ~2,100 ft, crowned by the historic Peshwa-era Parvati Temple. A 103-step climb rewards visitors with rooftop city views, a small museum, and serene gardens—popular at sunrise and for spiritual solace." 
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Housing 20,000+ artifacts—ranging from decorative arts to musical instruments—this museum offers a vivid window into daily life in historical India. It recently introduced geofenced multilingual audio guides across its eight galleries. " 
  },
  {
    "title": "Shinde Chhatri",
    "description": "A memorial dedicated to Maratha warrior Mahadji Shinde (d.1794), featuring Rajasthani-style carved pavilions, colored glass windows, and serene courtyards. It marks both his cremation spot and enduring legacy." 
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spanning 130 acres at Pune’s edge, this family-friendly park includes a zoo, snake park, aviary, and botanical sections. It combines wildlife conservation with educational exhibits and picnic spaces." 
  }
],

"services": [
  {
    "name": "Book Ertiga Taxi in Pune",
    "description": "Reserve a reliable and spacious Ertiga taxi in Pune for your travel needs. Whether for city rides, outstation trips, or business travel, our Ertiga cabs offer a perfect balance of comfort, space, and affordability, along with experienced chauffeurs."
  },
  {
    "name": "Ertiga Car Hire Pune for Outstation",
    "description": "Planning an outstation journey from Pune? Hire our Ertiga cars for a smooth and comfortable ride. Ideal for families or small groups, our outstation packages include AC comfort, ample luggage space, and courteous drivers who know the routes well."
  },
  {
    "name": "AC Ertiga Cab Pune",
    "description": "Beat the heat with our fully air-conditioned Ertiga cabs in Pune. Perfect for local and long-distance travel, these vehicles are well-maintained, clean, and ensure a cool and relaxing ride with plenty of room for up to 6 passengers."
  },
  {
    "name": "Affordable Ertiga Rental in Pune",
    "description": "Looking for a budget-friendly yet spacious vehicle in Pune? Our affordable Ertiga rentals give you the best of both — cost-efficiency and comfort. Ideal for families, airport transfers, and short weekend trips without breaking the bank."
  },
  {
    "name": "Ertiga for Family Trips Pune",
    "description": "Make your family outings in and around Pune special with our Ertiga cab service. With 6-seater capacity, rear AC vents, and professional drivers, you’ll enjoy a secure and pleasant journey tailored for family comfort."
  },
  {
    "name": "Pune to Mumbai Ertiga Cab",
    "description": "Travel between Pune and Mumbai comfortably with our Ertiga cabs. Enjoy spacious seating, AC comfort, and punctual service for a smooth ride whether you’re heading for business, leisure, or airport pickups and drop-offs."
  },
  {
    "name": "Online Booking for Ertiga Pune",
    "description": "Book your Ertiga taxi in Pune easily with our online platform. Choose vehicle type, set pickup times, and confirm your booking instantly with transparent pricing and reliable customer support for a seamless experience."
  },
  {
    "name": "6-Seater Cab Ertiga Pune",
    "description": "Need a 6-seater cab in Pune? Our Ertiga cabs are the perfect solution for group travel, family tours, or friends’ outings. Enjoy comfortable seating, ample luggage room, and well-trained drivers who ensure a safe journey."
  },
  {
    "name": "SUV Cab Pune Ertiga Hire",
    "description": "Hire an SUV-style Ertiga cab in Pune for your next journey. Combining fuel efficiency with utility, this compact MPV is ideal for travelers who need space and comfort without the higher costs of full-size SUVs."
  },
  {
    "name": "Pune Airport Transfer by Ertiga",
    "description": "Get timely and comfortable transfers to or from Pune Airport in an Ertiga cab. With enough room for passengers and luggage, it’s a perfect choice for families and groups looking for punctual and stress-free airport rides."
  },
  {
    "name": "Chauffeur Driven Ertiga Pune",
    "description": "Enjoy a premium travel experience with our chauffeur-driven Ertiga service in Pune. Our drivers are trained, punctual, and polite, ensuring a professional and relaxing ride whether you're heading outstation or across the city."
  },
  {
    "name": "Group Cab Pune Ertiga Service",
    "description": "Travel together with ease using our group cab service in Pune featuring the versatile Ertiga. Ideal for small teams, families, or friends, these cabs offer group convenience with the assurance of comfort and safety."
  },
  {
    "name": "Comfortable Ride Pune Ertiga Cab",
    "description": "Ride in comfort with our Ertiga cabs in Pune. With ergonomic seats, air conditioning, and ample legroom, our cabs are ideal for longer journeys or day-long travel plans around the city or beyond."
  },
  {
    "name": "Ertiga for City Travel Pune",
    "description": "Explore Pune with ease in an Ertiga cab. Our drivers know the city routes well, and the vehicle’s size makes it perfect for urban travel — spacious enough for your group yet compact enough to handle city traffic efficiently."
  },
  {
    "name": "Round Trip Ertiga Cab Pune",
    "description": "Plan round trips from Pune effortlessly with our Ertiga cabs. Whether it’s a one-day return or multiple-day plan, enjoy flexible scheduling, dependable drivers, and comfortable travel every step of the way."
  }
],
"tableData": [
  ["Book Ertiga Taxi in Pune", "Ertiga Car Hire Pune for Outstation"],
  ["AC Ertiga Cab Pune", "Affordable Ertiga Rental in Pune"],
  ["Ertiga for Family Trips Pune", "Pune to Mumbai Ertiga Cab"],
  ["Online Booking for Ertiga Pune", "6-Seater Cab Ertiga Pune"],
  ["SUV Cab Pune Ertiga Hire", "Pune Airport Transfer by Ertiga"],
  ["Chauffeur Driven Ertiga Pune", "Group Cab Pune Ertiga Service"],
  ["Comfortable Ride Pune Ertiga Cab", "Ertiga for City Travel Pune"],
  ["Round Trip Ertiga Cab Pune", ""]
],
"whychoose": [
    {
        "WhyChooseheading": "Comfortable Ertiga Cab Service in Pune",
        "WhyChoosedescription": "Meghana Cab offers premium Ertiga cab services in Pune, ideal for small families and groups seeking a spacious, comfortable, and affordable travel option. The Ertiga’s roomy interiors and smooth ride make it perfect for city travel as well as outstation trips."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Our Ertiga cabs are regularly serviced and thoroughly sanitized to ensure safety and hygiene. Equipped with air-conditioning and comfortable seating, these vehicles provide a clean and relaxing environment for your journeys."
    },
    {
        "WhyChooseheading": "Experienced and Friendly Drivers",
        "WhyChoosedescription": "Our professional drivers are knowledgeable about Pune’s routes and traffic conditions. They offer courteous, punctual, and safe driving, helping you reach your destination comfortably and on time."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "We provide upfront and competitive pricing for our Ertiga cab services, including all charges like fuel, tolls, driver allowance, and taxes. No hidden fees ensure a hassle-free booking experience with excellent value for your money."
    },
    {
        "WhyChooseheading": "Flexible Booking and Travel Plans",
        "WhyChoosedescription": "Whether you need a short city ride, hourly rental, or a long-distance trip, our Ertiga cabs offer flexible booking options tailored to your needs. Customize your pickup and drop locations, trip duration, and stops to suit your schedule."
    },
    {
        "WhyChooseheading": "Ideal for Family Outings and Small Group Travel",
        "WhyChoosedescription": "With spacious seating for up to 7 passengers, the Ertiga is perfect for family outings, group excursions, and airport transfers. Enjoy a comfortable and enjoyable journey with ample legroom and luggage space."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Our dedicated customer support team is available 24/7 to assist with bookings, modifications, and special requests. Experience a smooth and hassle-free booking process with Meghana Cab’s Ertiga service."
    },
    {
        "WhyChooseheading": "Safe and Reliable Travel Experience",
        "WhyChoosedescription": "Safety is our priority. Our Ertiga cabs are driven by experienced drivers who follow all safety protocols, ensuring you have a secure and dependable journey every time you travel with us."
    }
  ]
}
const faqData = [
    {
        question: "How can I book an Ertiga cab in Pune with Meghana Cab?",
        answer: "You can book your Ertiga cab in Pune by calling Meghana Cab at +91 9075462128 or through our website for fast and easy booking."
    },
    {
        question: "What are the benefits of choosing an Ertiga cab?",
        answer: "Our Ertiga cabs provide spacious seating, comfort, and are ideal for family trips and group travel within Pune."
    },
    {
        question: "Are Meghana Cab drivers experienced with Ertiga vehicles?",
        answer: "Yes, our drivers are well-trained and experienced in driving Ertiga cabs for a smooth and safe journey."
    },
    {
        question: "Is the Ertiga cab service available for local and outstation trips?",
        answer: "Yes, you can book Ertiga cabs for both local Pune travel and outstation journeys."
    },
    {
        question: "Does the fare include fuel, tolls, and driver charges?",
        answer: "Our fares cover fuel, tolls, and driver charges. Additional waiting time or parking fees may incur extra charges."
    },
    {
        question: "Are the Ertiga vehicles sanitized before trips?",
        answer: "Yes, all Ertiga cabs are thoroughly sanitized before every trip to ensure your safety."
    },
    {
        question: "Is the Ertiga cab service available 24/7 in Pune?",
        answer: "Yes, Meghana Cab provides 24/7 Ertiga cab service to fit your schedule."
    },
    {
        question: "Can I request stops for meals or sightseeing during the ride?",
        answer: "Yes, stops can be arranged upon request. Please inform us when booking."
    },
    {
        question: "What payment methods are accepted for Ertiga cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How do I contact Meghana Cab to book an Ertiga cab in Pune?",
        answer: "Call us anytime at +91 9075462128 to book your Ertiga cab or get assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rahul Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Ertiga cab service in Pune was very comfortable and spacious. Driver was courteous and punctual.”',
    },
    {
        name: 'Ms. Nisha More',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great experience with Meghana Cab’s Ertiga service. Highly recommended for group travel.”',
    },
];













































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const ertigaCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Ertiga Cab Service in Pune",
  "image": "https://www.meghanacabs.com/assets/images/ertiga-cab-pune.jpg",
  "description": "Book Ertiga taxi in Pune for outstation trips, airport transfers, family travel, and group rides. Affordable, AC, and chauffeur-driven Ertiga cabs available with Meghana Cabs.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "Book Ertiga Taxi in Pune",
    "Ertiga Car Hire Pune for Outstation",
    "AC Ertiga Cab Pune",
    "Affordable Ertiga Rental in Pune",
    "Ertiga for Family Trips Pune",
    "Pune to Mumbai Ertiga Cab",
    "Online Booking for Ertiga Pune",
    "6-Seater Cab Ertiga Pune",
    "SUV Cab Pune Ertiga Hire",
    "Pune Airport Transfer by Ertiga",
    "Chauffeur Driven Ertiga Pune",
    "Group Cab Pune Ertiga Service",
    "Comfortable Ride Pune Ertiga Cab",
    "Ertiga for City Travel Pune",
    "Round Trip Ertiga Cab Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};







    return (
        <div>

<Helmet>
  <title>Ertiga Cab Service in Pune</title>
  <meta
    name="description"
    content="Book Ertiga taxi in Pune for outstation trips, airport transfers, family travel, and group rides. Affordable, AC, and chauffeur-driven Ertiga cabs available with Meghana Cabs."
  />
  <meta
    name="keywords"
    content="Book Ertiga Taxi in Pune, Ertiga Car Hire Pune for Outstation, AC Ertiga Cab Pune, Affordable Ertiga Rental in Pune, Ertiga for Family Trips Pune, Pune to Mumbai Ertiga Cab, Online Booking for Ertiga Pune, 6-Seater Cab Ertiga Pune, SUV Cab Pune Ertiga Hire, Pune Airport Transfer by Ertiga, Chauffeur Driven Ertiga Pune, Group Cab Pune Ertiga Service, Comfortable Ride Pune Ertiga Cab, Ertiga for City Travel Pune, Round Trip Ertiga Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(ertigaCabSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/52.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>
                            <div className="row twm-faq-section-1 m-b30">
                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Ertigacabpune;